<template>
  <!-- Footer -->
  <footer id="page-footer">
    <slot>
      <div class="content py-3">
        <b-row class="font-size-sm">
          <b-col sm="6" order-sm="1" class="py-1 text-center text-sm-left">
            egf PCT &copy; egf - Eduard G. Fidel GmbH
          </b-col>
        </b-row>
      </div>
    </slot>
  </footer>
  <!-- END Footer -->
</template>

<script>
export default {
  name: "BaseFooter",
  props: {
    classes: String
  }
};
</script>
